export default __webpack_public_path__ + "static/SuisseIntl-SemiBold-18c0fbcadfe07a5cc1bf8ee1548f4423.woff2";